/*
 * @Description: 主机端口
 * @Author: 房旭
 * @Date: 2019-02-17 10:58:03
 * @LastEditors: 房旭
 * @LastEditTime: 2019-05-23 09:52:12
 */

/**
 * @description: 研发主机
 * @param {type} 
 * @return: 
 */
const workBaseURL = process.env.NODE_ENV === 'production' ? '' : "http://yanfa.bkcc.com.cn"

export {
    workBaseURL
};

/**
 * @description: 项目版本号
 * @param {type} 
 * @return: 
 */
export const versions = 'BKCC_V.X.01.01.02'